/**
 * axisFormat — o tick de DINHEIRO do eixo Y dos relatórios.
 *
 * ⚠️ Armadilha #43: o padrão copiado entre gráficos era
 * `margin={{ left: -10 }}` + `formatBRLShort` no `tickFormatter`. Com valores
 * abaixo de mil, `formatBRLShort` devolve "R$ 750,00" — largo demais para a
 * faixa do eixo, e numa tela de 360px o **"R$" sai CORTADO**. Não é um bug que
 * `tsc` ou jsdom peguem: o texto existe, só está clipado pelo SVG. Só apareceu
 * numa captura de tela do device.
 *
 * A correção tem três partes e as três são necessárias:
 *   1. abaixo de mil, mostrar sem centavos ("R$ 750") — num eixo os centavos não
 *      informam nada;
 *   2. `width={58}` explícito no `<YAxis>`;
 *   3. `margin.left: 0` (não `-10`).
 *
 * O Relatório de Pagamentos já corrigia isso com uma cópia local da função; o de
 * Estoque, com outra (de quantidade). Agora a de dinheiro mora aqui, para o
 * próximo gráfico não herdar o defeito de novo — foi exatamente assim que o
 * gráfico "Faturamento mensal" ficou anos com a falha latente registrada no #43.
 */
import { formatBRLShort } from '@/lib/financeLabels';

/** Largura da faixa do eixo Y, em px. Combina com {@link moneyAxisTick}. */
export const MONEY_AXIS_WIDTH = 58;

export function moneyAxisTick(value: number): string {
  const n = Number(value) || 0;
  return Math.abs(n) >= 1000 ? formatBRLShort(n) : `R$ ${Math.round(n)}`;
}
